import { notify } from 'notiwind';

function $error(title, text) {
  return notify(
    {
      title,
      text,
      type: 'error'
    },
    -1
  );
}

function $success(title, text) {
  return notify(
    {
      title,
      text,
      type: 'success'
    },
    -1
  );
}

function $warning(title, text) {
  return notify(
    {
      title,
      text,
      type: 'warning'
    },
    -1
  );
}

function $info(title, text) {
  return notify(
    {
      title,
      text,
      type: 'info'
    },
    -1
  );
}

export {
  $error,
  $success,
  $warning,
  $info,
  notify
};
